'use client';
import styles from '../../page.module.scss';
import Link from 'next/link';
import { FaFacebookF } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { useEffect, useState } from 'react';

interface ShareIconsProps {
  title?: string;
  description?: string;
  url?: string;
}

const ShareIcons: React.FC<ShareIconsProps> = ({ title = '', description = '', url }) => {
  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    // Obtener la URL actual del navegador
    setCurrentUrl(url || window.location.href);
  }, [url]);

  // Función para codificar texto para URLs
  const encodeText = (text: string) => encodeURIComponent(text);

  // Función para compartir en Instagram
  const handleInstagramShare = () => {
    const textToShare = title ? `${title} - ${currentUrl}` : currentUrl;

    // Intentar abrir la app de Instagram si está en móvil
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);

    if (isMobile) {
      // Intentar abrir la app de Instagram
      window.location.href = 'instagram://';

      // Fallback: copiar al portapapeles después de un breve delay
      setTimeout(() => {
        copyToClipboard(textToShare);
      }, 2000);
    } else {
      // En escritorio, copiar al portapapeles
      copyToClipboard(textToShare);
    }
  };

  // Función para copiar al portapapeles
  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert('¡Enlace copiado! Ahora puedes pegarlo en tu historia o post de Instagram.');
    } catch (err) {
      console.error('Error al copiar al portapapeles:', err);
      // Fallback para navegadores que no soportan clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert('¡Enlace copiado! Ahora puedes pegarlo en tu historia o post de Instagram.');
    }
  };

  // URLs para compartir en cada red social
  const shareUrls = {
    whatsapp: `https://wa.me/?text=${encodeText(title ? `${title} - ${currentUrl}` : currentUrl)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeText(currentUrl)}`,
  };

  return (
    <div>
      <div className={styles.shareIconsContainer}>
        <Link
          className={styles.socialIcon}
          href={shareUrls.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp />
        </Link>
        <Link
          className={styles.socialIcon}
          href={shareUrls.facebook}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebookF />
        </Link>
        <div className={styles.socialIcon} onClick={handleInstagramShare}>
          <FaInstagram />
        </div>
      </div>
    </div>
  );
};

export default ShareIcons;
